import { render } from "./SimpleMenu.vue?vue&type=template&id=53896668"
import script from "./SimpleMenu.vue?vue&type=script&lang=js"
export * from "./SimpleMenu.vue?vue&type=script&lang=js"

import "./SimpleMenu.vue?vue&type=style&index=0&id=53896668&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__